export const TICKET_EXTENDED_EVENT = "mosida:ticket-extended";
